import { useState } from "react";
import AddExistingUser from "./AddExistingUser";
import AddNewUser from "./AddNewUser";
import LinkResearcher from "./LinkResearcher";

const AddUsers = () => {
  const [choice, setChoice] = useState("existing");

  return (
    <>
      {/* Buttons */}
      <div className="flex items-center justify-center gap-4 mb-6">
        <button
          type="button"
          onClick={() => setChoice("existing")}
          className={`px-4 py-2 rounded text-white transition ${
            choice === "existing" ? "bg-blue-700" : "bg-blue-500 hover:bg-blue-600"
          }`}
        >
          Select From Existing Users
        </button>

        <button
          type="button"
          onClick={() => setChoice("manual")}
          className={`px-4 py-2 rounded text-white transition ${
            choice === "manual" ? "bg-blue-700" : "bg-blue-500 hover:bg-blue-600"
          }`}
        >
          Add User Manually
        </button>

        <button
          type="button"
          onClick={() => setChoice("researcher")}
          className={`px-4 py-2 rounded text-white transition ${
            choice === "researcher" ? "bg-blue-700" : "bg-blue-500 hover:bg-blue-600"
          }`}
        >
          Link Researcher
        </button>
      </div>

      {/* Conditional Rendering */}
      {choice === "existing" && <AddExistingUser />}
      {choice === "manual" && <AddNewUser />}
      {choice === "researcher" && <LinkResearcher />}
    </>
  );
};

export default AddUsers;
